export const LOCKED_TERMINAL_STATUSES = [
  'cancelled',
  'closed',
  'expired',
  'lost',
  'rejected',
  'withdrawn',
];

/**
 * How long (in weeks) an interaction stays unlocked before reverting to locked.
 * After this window elapses the unlock flow must be completed again.
 */
export const INTERACTION_UNLOCK_DURATION_WEEKS = 1;

/**
 * When transaction status automation is enabled the status is driven by
 * automation while the interaction is pending or closed, so the status dropdown is
 *  locked (shown read-only) rather than editable.
 */
export const STATUS_AUTOMATION_LOCKED_STATUS = ['pending', 'closed'];

/**
 * Terminal statuses the user may still manually transition out of (subject to
 * the audit check) when transaction status automation is enabled.
 */
export const MANUAL_TRANSITION_TERMINAL_STATUSES = [
  'expired',
  'lost',
  'rejected',
];
